@if (show && modalService.newRegularWithdrawal) {
    <div class="cancel-regular-container">
      <div class="header">
        {{ 'modal.createWithdrawal.header' | translate }}
      </div>
      <p>
        @if(modalService.newRegularWithdrawal.dip) {
          <p>
            <span>
              {{ ('modal.createWithdrawal.dipConfirmPart1' + modalService.newRegularWithdrawal.investmentType) | translate }}
              <b>"{{ modalService.newRegularWithdrawal.investmentName }}"</b>
              {{ 'modal.createWithdrawal.dipConfirmPart2' | translate }}
              <b>{{ modalService.newRegularWithdrawal.formData.value | price:'CZK' }}</b>
              {{ 'modal.createWithdrawal.dipConfirmPart3' | translate }}
              <b>{{ modalService.newRegularWithdrawal.bankAccountNumber }}</b>.
            </span>
          </p>
          <p>
            {{ ('modal.createWithdrawal.dipConfirmPart4' + modalService.newRegularWithdrawal.investmentType) | translate }}
            {{ 'modal.createWithdrawal.dipConfirmPart5' | translate }}
          </p>
          <p>{{ 'modal.createWithdrawal.dipConfirmPart6' | translate }}</p>
          <p><b>{{ 'modal.createWithdrawal.dipConfirmPart7' | translate }}</b></p>
          <p>{{ 'modal.createWithdrawal.dipConfirmPart8' | translate }}</p>
        } @else {
          <p>
            <span>
              {{ ('modal.createWithdrawal.confirmPart1' | translate) +
              (('modal.createWithdrawal.confirmPart2' + modalService.newRegularWithdrawal.investmentType) | translate )}}
              <b>"{{ modalService.newRegularWithdrawal.investmentName }}"</b>
              {{ 'modal.createWithdrawal.confirmPart3' | translate }}
              <b>{{ modalService.newRegularWithdrawal.bankAccountNumber }}</b>{{
              (('modal.createWithdrawal.confirmPart4' + modalService.newRegularWithdrawal.formData.frequency) | translate) +
              (('modal.createWithdrawal.confirmPart5' + (modalService.newRegularWithdrawal.formData.validTo ? 'Limited' : 'Unlimited')) | translate) +
              ('modal.createWithdrawal.confirmPart6' | translate) }}
              <b>{{ modalService.newRegularWithdrawal.formData.value | price:'CZK' }}</b>?
            </span>
          </p>
        }
      </p>

      <div class="regular-withdrawal-buttons">
        <div class="btn-wrapper">
          <libero-button
            label="{{ 'global.buttons.back' | translate }}"
            btnClasses="btn--icon-text icon--secondary btn--wrap-text btn--lg-auto-width"
            (click)="onBackBtnClick()"
            data-cy="rent-confirm-withrawal-back-btn"
          ></libero-button>
        </div>
        <libero-button
          label="{{ 'global.buttons.confirm' | translate }}"
          btnClasses="btn--primary btn--heading"
          (click)="onContinueBtnClick()"
          data-cy="rent-confirm-withrawal-btn"
        ></libero-button>
      </div>
    </div>
}
